// Validating the JSA V2
import * as jsaCoreValidation from "./jsa_validation/core";
import * as jsaV2Validation from "./jsa_validation/v2";

// Validating the JSA V2 Draft
export const validateJsaV2Draft = (jsa) => {
  console.log("JSA V2 Draft:", jsa);
  const errors = {
    basicInfo: null,
    rac: null,
    training: null,
    employeeSignatures: null,
    nonEmployeeSignatures: null,
    hazardsV2: null,
    controlMeasuresV2: null,
  };

  // Validating the JSA Core items first
  const basicInfoErrors = jsaCoreValidation.validateJsaBasicInfoDraft(
    jsa.jsaBasicInfo
  );

  if (basicInfoErrors) {
    errors.basicInfo = basicInfoErrors;
  }

  // Validating the JSA RAC
  const racErrors = jsaCoreValidation.validateJsaRac(jsa.jsaRacInfo);

  if (racErrors) {
    errors.rac = racErrors;
  }

  // Validating the JSA Training, commented out since I don't think we will need it right now.
  // const trainingErrors = jsaCoreValidation.validateJsaTraining(
  //   jsa.jsaTrainingInfo
  // );

  // if (trainingErrors) {
  //   errors.training = trainingErrors;
  // }

  // Validating the JSA Employee Signatures
  const employeeSignaturesErrors =
    jsaCoreValidation.validateJsaEmployeeSignaturesDraft(
      jsa.jsaEmployeeSignaturesInfo
    );

  if (employeeSignaturesErrors) {
    errors.employeeSignatures = employeeSignaturesErrors;
  }

  // Validating the JSA Non Employee Signatures
  const nonEmployeeSignaturesErrors =
    jsaCoreValidation.validateJsaNonEmployeeSignaturesDraft(
      jsa.jsaNonEmployeeSignaturesInfo
    );

  if (nonEmployeeSignaturesErrors) {
    errors.nonEmployeeSignatures = nonEmployeeSignaturesErrors;
  }

  // Validating the JSA Hazards V2
  const hazardsV2Errors = jsaV2Validation.validateJsaHazardsV2(
    jsa.jsaHazardsV2
  );

  if (hazardsV2Errors) {
    errors.hazardsV2 = hazardsV2Errors;
  }

  return errors;
};

// Validating the JSA V2 DEL Submitted
export const validateJsaV2DelSubmitted = (jsa) => {
  const errors = {
    basicInfo: null,
    rac: null,
    training: null,
    employeeSignatures: null,
    nonEmployeeSignatures: null,
    hazardsV2: null,
    controlMeasuresV2: null,
  };

  // Validating the JSA Core items first
  const basicInfoErrors = jsaCoreValidation.validateJsaBasicInfoSubmitted(
    jsa.jsaBasicInfo
  );

  if (basicInfoErrors) {
    errors.basicInfo = basicInfoErrors;
  }

  // Validating the JSA RAC
  const racErrors = jsaCoreValidation.validateJsaRac(jsa.jsaRacInfo);

  if (racErrors) {
    errors.rac = racErrors;
  }

  // Validating the JSA Training
  const trainingErrors = jsaCoreValidation.validateJsaTraining(
    jsa.jsaTrainingInfo
  );

  if (trainingErrors) {
    errors.training = trainingErrors;
  }

  // Validating the JSA Employee Signatures
  const employeeSignaturesErrors =
    jsaCoreValidation.validateJsaEmployeeSignaturesSubmitted(
      jsa.jsaEmployeeSignaturesInfo
    );

  if (employeeSignaturesErrors) {
    errors.employeeSignatures = employeeSignaturesErrors;
  }

  // Validating the JSA Non Employee Signatures
  const nonEmployeeSignaturesErrors =
    jsaCoreValidation.validateJsaNonEmployeeSignaturesSubmitted(
      jsa.jsaNonEmployeeSignaturesInfo
    );

  if (nonEmployeeSignaturesErrors) {
    errors.nonEmployeeSignatures = nonEmployeeSignaturesErrors;
  }

  // Validating the JSA Hazards V2
  const hazardsV2Errors = jsaV2Validation.validateJsaHazardsV2(
    jsa.jsaHazardsV2
  );

  if (hazardsV2Errors) {
    errors.hazardsV2 = hazardsV2Errors;
  }

  return errors;
};
